/**
 * Notification type constants — mirrors the backend NotificationType enum.
 * Use these instead of raw strings throughout the frontend.
 */
const NotificationTypes = Object.freeze({
  // Job plan reminders
  JOBPLAN_4_HOURS: 'JOBPLAN_4_HOURS',
  JOBPLAN_6_HOURS: 'JOBPLAN_6_HOURS',

  // Birthday reminders
  TOMORROW_BIRTHDAY_REMINDER: 'TOMORROW_BIRTHDAY_REMINDER',
  TODAY_BIRTHDAY_REMINDER: 'TODAY_BIRTHDAY_REMINDER',

  // Work anniversary reminders
  TOMORROW_JOINDAY_REMINDER: 'TOMORROW_JOINDAY_REMINDER',
  TODAY_JOINDAY_REMINDER: 'TODAY_JOINDAY_REMINDER',

  // Performance reviews
  MONTHLY_PROGRESS_REVIEW: 'MONTHLY_PROGRESS_REVIEW',
  QUARTERLY_PERFORMANCE_REVIEW: 'QUARTERLY_PERFORMANCE_REVIEW',
  PROBATION_PERIOD_END: 'PROBATION_PERIOD_END',
  FIRST_YEAR_PERFORMANCE_REVIEW: 'FIRST_YEAR_PERFORMANCE_REVIEW',

  // Leave
  LEAVE_APPLIED: 'LEAVE_APPLIED',
  LEAVE_APPROVED: 'LEAVE_APPROVED',
  LEAVE_REJECTED: 'LEAVE_REJECTED',
});

export default NotificationTypes;
